(function ($, _, w) {
    if (!w.checkoutProviders) {
        w.checkoutProviders = {};
    }

    w.checkoutController = (function () {
        var _self;
        var _orderForm = null;
        var _resetOrderInProvider = false;
        var _deliveryCountryCode, _deliveryPostalCode, _deliveryPostalArea;
        var _deliveryDetails = null;
        var _deliveryDate, _isDeliveryDateRequired = false, _isDateRequiredBySelectedDelivery = false;
        var _orderComment = null;
        var _extraFields = null;
        var _checkouts = {}, _selectedCheckout;
        var _settings;
        var _isCartChangedSinceLastUpdate = false;
        var _paymentReferenceId = null;
        var _$deferredInitializedPaymentHandling = null;

        function _getOrderForm(ignorePostalAreaFromCheckoutProvider) {
            var checkout = _selectedCheckout;
            var orderForm = checkout.getOrderFormValues();

            orderForm.paymentId = checkout.getPaymentId();
            orderForm.paymentProviderRefId = _paymentReferenceId;
            orderForm.deliveryId = _deliveryDetails.deliveryID;
            orderForm.deliveryDate = _deliveryDate;
            orderForm.providerCheckboxChecked = _deliveryDetails.providerCheck;
            orderForm.providerInputMessage = _deliveryDetails.providerInputMessage;
            orderForm.providerPickupPointId = _deliveryDetails.providerPickupPointId;

            if (_orderComment) {
                orderForm.comment = _orderComment;
            }
            if (_extraFields) {
                orderForm.extraFields = _extraFields;
            }

            if (!orderForm.deliveryAddress) {
                orderForm.deliveryAddress = {};
            }
            if (!orderForm.deliveryAddress.countryCode) {
                orderForm.deliveryAddress.countryCode = _deliveryCountryCode;
            }
            if (_settings.isDeliveryPostalCodeReadonly || !orderForm.deliveryAddress.postalCode) {
                orderForm.deliveryAddress.postalCode = _deliveryPostalCode;
            }
            if (ignorePostalAreaFromCheckoutProvider || (!orderForm.deliveryAddress.postalArea && _deliveryPostalArea)) {
                orderForm.deliveryAddress.postalArea = _deliveryPostalArea;
            }

            if (!orderForm.billingAddress) {
                orderForm.billingAddress = orderForm.deliveryAddress;
            }

            return orderForm;
        }
        function _checkInputsAndUpdateOrder(ignorePostalAreaFromCheckoutProvider, blockUi) {
            if (_$deferredInitializedPaymentHandling) {
                return;
            }

            var deliveryId = _deliveryDetails ? _deliveryDetails.deliveryID : -1;

            var requiredInputsProvided = Boolean(_deliveryCountryCode && deliveryId >= 0 && (!_isDeliveryDateRequired || !_isDateRequiredBySelectedDelivery || _deliveryDate) && _selectedCheckout);

            if (!requiredInputsProvided) {
                return;
            }

            _updateInitializedOrder(ignorePostalAreaFromCheckoutProvider, blockUi);

            function _updateInitializedOrder(ignorePostalAreaFromCheckoutProvider, blockUi) {
                var checkout = _selectedCheckout;
                var orderForm = _getOrderForm(ignorePostalAreaFromCheckoutProvider);
                if (_resetOrderInProvider) {
                    _resetOrderInProvider = false;
                    orderForm.resetOrderInProvider = true;
                }

                blockUi |= _shouldRecalculateOrder(_orderForm, orderForm);
                _orderForm = orderForm;

                if (blockUi) {
                    checkout.suspendForUpdate();

                    if (_settings && typeof _settings.blockUi === 'function') {
                        _settings.blockUi();
                    }
                }
                var request = {
                    url: w.R + 'api/checkout/order/init' + (_isCartChangedSinceLastUpdate ? '?updateFromCart=true' : ''),
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    data: JSON.stringify(orderForm)
                };
                $.ajax(request)
                    .done(function(result) {
                        if (result.initializedCheckoutOrder) {
                            _isCartChangedSinceLastUpdate = false;
                            _paymentReferenceId = result.initializedCheckoutOrder.paymentReferenceId;
                            checkout.handleUpdatedOrder(result.initializedCheckoutOrder.paymentOrder);

                            var deliveryAddress = result.initializedCheckoutOrder.deliveryAddress;
                            if (deliveryAddress) {
                                _deliveryCountryCode = deliveryAddress.countryCode;
                                _deliveryPostalCode = deliveryAddress.postalCode;
                            }

                            if (_settings && typeof _settings.onCheckoutAvailable === 'function') {
                                const checkoutSpecifics = typeof checkout.getSpecifics === 'function' ? checkout.getSpecifics() : {};
                                _settings.onCheckoutAvailable(checkout.getPaymentId(), checkoutSpecifics, result.initializedCheckoutOrder);
                            }
                        } else {
                            if (_settings && typeof _settings.onCheckoutUnavailable === 'function')
                                _settings.onCheckoutUnavailable(checkout.getPaymentId(), result.errorMsg ? result.errorMsg : 'Sorry, something went wrong');
                        }
                    })
                    .fail(function(errorResponse) {
                        console.error('[UMW]: Failed to update initialized order', errorResponse);
                    })
                    .always(function (){
                        if (blockUi && _settings && typeof _settings.unBlockUi === 'function') {
                            _settings.unBlockUi();
                        }
                    });
            }
            function _shouldRecalculateOrder(prevForm, newForm) {
                if (!prevForm || _isCartChangedSinceLastUpdate) {
                    return true;
                }

                return prevForm.paymentId !== newForm.paymentId ||
                    prevForm.deliveryId !== newForm.deliveryId ||
                    prevForm.deliveryAddress.countryCode !== newForm.deliveryAddress.countryCode ||
                    prevForm.deliveryAddress.postalCode !== newForm.deliveryAddress.postalCode;
            }
        }
        function _confirmOrder(blockUi) {
            if (!_paymentReferenceId) {
                w.PubSub.publish('notification', { type: 'error', text: 'Payment reference id was not found.' });
                console.error('[UMW]: Payment reference id was not found');
                return;
            }

            var checkout = _selectedCheckout;
            var orderForm = _getOrderForm();

            _orderForm = orderForm;

            if (blockUi) {
                if (_settings && typeof _settings.blockUi === 'function') {
                    _settings.blockUi();
                }
            }
            var request = {
                url: w.R + 'api/checkout/order/confirm-initialized',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(orderForm),
            };
            $.ajax(request)
                .done(function (result) {
                    if (!result) {
                        w.PubSub.publish('notification', { type: 'error', text: 'Empty result' });
                        console.error('[UMW]: Empty result');
                    } else if (result.errorMsg) {
                        w.PubSub.publish('notification', { type: 'error', text: result.errorMsg });
                        console.error('[UMW]: ' + result.errorMsg);
                    } else {
                        checkout.handleConfirmOrder(result.paymentProviderInternalData);
                    }
                })
                .fail(function (errorResponse) {
                    w.PubSub.publish('notification', { type: 'error', text: errorResponse });
                })
                .always(function () {
                    if (_settings && typeof _settings.unBlockUi === 'function') {
                        _settings.unBlockUi();
                    }
                });
        }

        (function subscribeToCartChangedEvent() {
            var estore = w.PublicEStore;
            estore.subscribe(estore.channels.callback.shopCart, function (channel, contract) {
                _isCartChangedSinceLastUpdate = true;
            });
        })();

        return _self = {
            init: function(settings) {

                settings = $.extend({
                        checkouts: {},
                        isDeliveryDateRequired: false,
                        isDeliveryPostalCodeReadonly: false, // set to true if delivery postal code input is handled by the control. In this case checkouts shell not allow user modify it

                        initializedPaymentMethodId: null,
                        initializedCheckoutOrder: null,

                        blockUi: function () {}, // used to block UI while order is being recalculated on the server
                        unBlockUi: function () {}, // used to unblock UI after order has been recalculated
                        onCheckoutAvailable: function (/*paymentId, checkoutSpecifics, initializedPayment*/) {}, // used to display checkout(s) container
                        onCheckoutUnavailable: function(/*paymentId, reasonMsg*/) {} // used to display checkout unavailable error message, disable current and switch to another checkout option
                    },
                    settings || {});

                _settings = settings;
                _isDeliveryDateRequired = settings.isDeliveryDateRequired;

                _.each(settings.checkouts,
                    function(checkoutDef) {
                        var Checkout = w.checkoutProviders[checkoutDef.providerName];
                        var checkoutSettings = { isDeliveryPostalCodeReadonly: _settings.isDeliveryPostalCodeReadonly };
                        var checkout = new Checkout(checkoutDef.paymentId, checkoutDef.$uiCont, _self, checkoutSettings);
                        _checkouts[checkoutDef.paymentId] = checkout;

                        if (checkoutDef.paymentId === _settings.initializedPaymentMethodId) {
                            _$deferredInitializedPaymentHandling = checkout.handleUpdatedOrder(_settings.initializedCheckoutOrder.paymentOrder);
                            if (_$deferredInitializedPaymentHandling) {
                                _$deferredInitializedPaymentHandling.always(function() {
                                    _$deferredInitializedPaymentHandling = null;
                                });
                            }
                            if (_settings && typeof _settings.onCheckoutAvailable === 'function') {
                                const checkoutSpecifics = typeof checkout.getSpecifics === 'function' ? checkout.getSpecifics() : {};
                                _settings.onCheckoutAvailable(checkoutDef.paymentId, checkoutSpecifics, _settings.initializedCheckoutOrder);
                            }
                        }
                        
                    });
            },

            setDeliveryInfo: function (deliveryAddress, delivery, isDateRequiredBySelectedDelivery) {
                if (!deliveryAddress) {
                    _deliveryDetails = _deliveryCountryCode = _deliveryPostalCode = _deliveryPostalArea = null;
                } else {
                    var changed = false, forcePostalArea = false;
                    if (_deliveryCountryCode !== deliveryAddress.countryCode) {
                        _deliveryCountryCode = deliveryAddress.countryCode;
                        changed = true;
                    }
                    if (_deliveryPostalCode !== deliveryAddress.postalCode) {
                        _deliveryPostalCode = deliveryAddress.postalCode;
                        if (deliveryAddress.postalArea != null) {
                            _deliveryPostalArea = deliveryAddress.postalArea;
                            forcePostalArea = true;
                        }
                        changed = true;
                    }
                    if (!_.isEqual(_deliveryDetails, delivery)) {
                        _deliveryDetails = delivery;
                        _isDateRequiredBySelectedDelivery = isDateRequiredBySelectedDelivery;
                        changed = true;
                    }
                    if (changed || _isCartChangedSinceLastUpdate) {
                        _checkInputsAndUpdateOrder(forcePostalArea);
                    }
                }
            },
            setDeliveryDate: function (date) {
                var changed = false;
                if (_deliveryDate !== date) {
                    _deliveryDate = date;
                    changed = true;
                }
                if (changed || _isCartChangedSinceLastUpdate) {
                    _checkInputsAndUpdateOrder();
                }
            },
            setOrderComment: function(comment) {
                var changed = false;
                if (_orderComment !== comment) {
                    _orderComment = comment;
                    changed = true;
                }
                if (changed || _isCartChangedSinceLastUpdate) {
                    _checkInputsAndUpdateOrder();
                }
            },
            setExtraFields: function (extraFields) {
                _extraFields = extraFields;
                _checkInputsAndUpdateOrder();
            },
            selectCheckout: function (paymentId, deliveryAddress) {
                _paymentReferenceId = null;
                var prevCheckout = _selectedCheckout;
                _selectedCheckout = paymentId > 0 ? _checkouts[paymentId] : null;
                if (prevCheckout !== _selectedCheckout || _isCartChangedSinceLastUpdate) {
                    if (deliveryAddress) {
                        _deliveryCountryCode = deliveryAddress.countryCode;
                        _deliveryPostalCode = deliveryAddress.postalCode;
                        _deliveryPostalArea = deliveryAddress.postalArea;
                    }

                    _checkInputsAndUpdateOrder();
                }
            },
            resetOrderInProviderOnNextUpdate() {
                _resetOrderInProvider = true;
            },

            // methods for checkout providers
            updateOrder: function (blockUi) {
                _checkInputsAndUpdateOrder(false, blockUi);
            },
            resetOrder: function() {
                _resetOrderInProvider = true;
                _checkInputsAndUpdateOrder(false, true);
            },
            confirmOrder: function(blockUi) {
                _confirmOrder(blockUi);
            }
        };
    })();
})(jQuery, _, window);